import { Component, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ValidationModalComponent } from 'src/app/shared/validation-modal/validation-modal.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CustomLuxonDateAdapter } from 'src/app/shared/utils/custom-luxon-date-adapter';
import { MY_FORMATS } from 'src/app/shared/utils/date-pickr-custom-luxon-format';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgentsService } from 'src/app/core/services/agents.service';
import { AlerteModalComponent } from 'src/app/shared/alerte-modal/alerte-modal.component';
import { take } from 'rxjs';
import { ServicesFonctionnelsService } from 'src/app/core/services/services-fonctionnels.service';

@Component({
    selector: 'app-edit-service-modal',
    imports: [
    MatTableModule,
    MatRadioModule,
    MatIconModule,
    MatCardModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatNativeDateModule,
    MatCheckboxModule,
    DragDropModule
],
    templateUrl: './edit-service-modal.component.html',
    styleUrls: ['./edit-service-modal.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: DateAdapter, useClass: CustomLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class EditServiceModalComponent {
  rowData: any = {};
  dateP = new DatePipe('fr-FR');
  action: string = '';
  //titre_action: string = 'Ajouter';
  selectedType: string = '';
  dataCampagne: any = '';
  texte_erreur_date: string = '';
  minDateDebutSaisie: Date;
  minDateFinSaisie: Date;
  minDateDebutValidation: Date;
  minDateFinValidation: Date;
  minDateArchivage: Date;
  agentList: any[] = [];
  listAgents: any = [];
  val_responsable: any = null;

  filteredAgents: any[] = [];
  agentsList: any[] = [];
  constructor(
    private readonly formBuilder: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EditServiceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly agentsService: AgentsService,
    private readonly servicesFonctionnelsService: ServicesFonctionnelsService,
    private readonly spinner: NgxSpinnerService
  ) {}

  form: FormGroup = this.formBuilder.group({
    service: [{ value: this.data['Service'], disabled: true }],
    responsable: [this.data['Responsable'], [Validators.required]]
  });
  ngOnInit() {
    this.val_responsable = this.data.responsable;
    this.form = this.formBuilder.group({
      service: [{ value: this.data.service ?? '', disabled: true }],
      responsable: [this.data.responsable, [Validators.required]]
    });

    this.rowData.id = this.data.id;

    this.loadAgents();
  }

  initForm() {
    this.form.patchValue({
      service: this.data['service'],
      responsable: this.data.responsable
    });
  }

  loadAgents() {
    this.agentsService
      .getAllAgentsDemandes('consultation')
      .pipe(take(1))
      .subscribe({
        next: (data) => {

          if (data && Array.isArray(data)) {
            this.agentsList = data;
            this.agentList = [...this.agentsList];
          }
        }
      });
  }

  responsableFilter(event: any): void {
    const value = event.target.value;

    if (!value) {
      this.agentList = [...this.agentsList];
      return;
    }

    if (typeof value !== 'string') {
      this.agentList = [];
      return;
    }

    const filterValue = value.toLowerCase().split(' ').join('');
    this.agentList = this.agentsList.filter((item: any) =>
      (item.nom + ' ' + item.prenom).toLowerCase().split(' ').join('').includes(filterValue)
    );
  }
  responsableDisplayFn(agent?: any): string {
    return agent ? agent.nom + ' ' + agent.prenom : '';
  }

  fermerModale() {
    // modification
    if (this.data['edition']) {
      this.dialogRef.close({ action: false });
    }
  }

  submitForm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.action === 'ajouter') {
    } else {
      this.modifierService();
    }
  }

  // Modifier un service
  modifierService() {
    let _data: any = {};

    _data['id'] = this.rowData.id;
    _data['service'] = this.form.controls['service'].value;
    _data['responsable'] = { id: this.form.controls['responsable'].value.id };

    this.servicesFonctionnelsService
      .modifierService(_data, _data.id)
      .pipe(take(1))
      .subscribe({
        next: (result: any) => {
          this.spinner.hide();
          this.dialogRef.close({ action: true });
          this.dialog.open(ValidationModalComponent, {
            width: '600px',
            data: {
              title: 'Confirmation',
              content: 'Le service a été modifié avec succès.'
            }
          });
        },
        error: (error) => {
          console.log('error: ', error);
          let erreur_texte = error.error.detail || error.error || error.statusText || error;

          this.dialog.open(AlerteModalComponent, {
            width: '640px',
            data: {
              title: 'Alerte',
              content: 'Erreur lors de la modification du service !',
              status: 'STATUS : ' + error.status,
              detail: 'DETAIL : ' + erreur_texte
            }
          });
        }
      });
  }
}
